var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31712 2.86437C5.31712 4.1243 4.29174 5.03764 3.03983 5.03764C1.79153 5.03764 0.789062 4.11851 0.789062 2.86437C0.789062 1.60451 1.81478 0.692139 3.06647 0.692139C4.31457 0.692139 5.31712 1.6101 5.31712 2.86437Z",
    fill: "#B3B3C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05236 6.75481V19.3308H1.02705V6.75481H5.05236Z",
    fill: "#B3B3C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92164 19.3308H10.9469V12.3076C10.9469 11.9318 10.9731 11.5563 11.0795 11.2876C11.3704 10.537 12.0326 9.75917 13.1447 9.75917C14.6014 9.75917 15.1841 10.9128 15.1841 12.6024V19.3308H19.2091V12.1197C19.2091 8.25681 17.223 6.45933 14.5746 6.45933C12.4395 6.45933 11.482 7.67808 10.947 8.53503V6.75481H6.92164C6.9745 7.9349 6.92164 19.3308 6.92164 19.3308Z",
    fill: "#B3B3C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.086b20ce72b4c0fadfcb7cc001eff7e6.svg";
export { ForwardRef as ReactComponent };